// extracted by mini-css-extract-plugin
export default {"confirmInvoiceModal":"ConfirmInvoiceModal_confirmInvoiceModal__6kQxZ","buttons":"ConfirmInvoiceModal_buttons__77osY","cancelButton":"ConfirmInvoiceModal_cancelButton__hXPEm"};